import { isRelayType } from "./relay-pagination-mjs";
import { GraphQLSchema, buildASTSchema, isListType, isNonNullType, parse } from "graphql";
export function capitalize(str) {
  return "".concat(str.charAt(0).toUpperCase()).concat(str.slice(1));
}
export function ensureExecutableGraphQLSchema(graphQLSchema) {
  if (!(graphQLSchema instanceof GraphQLSchema)) {
    if (typeof graphQLSchema === "string") {
      graphQLSchema = parse(graphQLSchema);
    }

    graphQLSchema = buildASTSchema(graphQLSchema, {
      commentDescriptions: true
    });
  }

  return graphQLSchema;
}
export function unwrapType(type) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    considerRelay: false,
    isList: false
  };

  if (options.considerRelay && isRelayType(type)) {
    var fields = type.getFields();
    return fields.edges ? unwrapType(fields.edges.type, options) : unwrapType(fields.node.type, options);
  }

  var isList = isListType(type);

  if (isList || isNonNullType(type)) {
    if (!options.isList) {
      options.isList = isList;
    }

    return unwrapType(type.ofType, options);
  }

  return {
    isList: options.isList,
    type: type
  };
}
